import { CaptionsData, ITranslation } from '@d-id/types';
import axios from 'axios';

export async function getTranslatedCaptions(
    translation: Pick<ITranslation, 'transcriptions' | 'modified_at'>
): Promise<Pick<CaptionsData, 'sentences'>> {
    const editedTranscriptionUrl = translation?.transcriptions?.find(({ version }) => version === 'edit')?.url;

    const originalTranscriptionUrl = translation?.transcriptions?.find(({ selected }) => selected)?.url;

    const transcriptionUrl = editedTranscriptionUrl || originalTranscriptionUrl;

    if (!transcriptionUrl) {
        throw new Error('No transcription url found');
    }

    const { data } = await axios.get(transcriptionUrl, { params: { cache_busting: translation.modified_at } });

    return data;
}
